/* script */

import { validaCpfCnpj } from "../functions/cpf-cnpj.js";
import { getUrlParameter, getUrlParameters } from '../functions/get-url-parameter';
import checkout from './checkout.vue';

const __vue_script__ = {
  extends: checkout,
  data() {
    var country, countryObj;

    var code = getUrlParameter("country");
    if (code) {
      countryObj = allCountries.find(function(c) { return c.iso2 === code.toLowerCase() });
    }
    if (!countryObj) {
      country = {
        name: "Brazil (Brasil)",
        iso2: "br",
        dialCode: "55",
        priority: 0,
        areaCodes: null
      }
    } else {
      country = JSON.parse(JSON.stringify(countryObj));
    }

    return {
      country: country,
      ddd: getUrlParameter("phoneac") || window.localStorage.getItem("ddd") || "",
      form: {
        country: "BR",
        name: getUrlParameter("name") || window.localStorage.getItem("name") || "",
        document: window.localStorage.getItem("document") || "",
        email: getUrlParameter("email") || window.localStorage.getItem("email") || "",
        confirm_email: getUrlParameter("email") || window.localStorage.getItem("email") || "",
        phone: getUrlParameter("phonenumber") || window.localStorage.getItem("phone") || "",
        instagram: window.localStorage.getItem("instagram") || "",
      },
      i_errors: {
        ddd: [],
        name: [],
        document: [],
        email: [],
        confirm_email: [],
        phone: [],
        instagram: []
      },
    }
  },
  watch: {
    country() {
      this.getCurrency(this.country.iso2);
    },
  },
  mounted() {
    window.$.getJSON(
      "https://ipwhois.app/json/",
      (data) => {
        if (data.country_code) {
          this.country.iso2 = data.country_code.toLowerCase();
          this.getCurrency(this.country.iso2);
        }
      }
    )
  },
  computed: {
    isBrazil() {
      return this.country.iso2 === "br";
    },
    documentMask() {
      return this.isBrazil ? ['###.###.###-##', '##.###.###/####-##'] : null
    },
    phoneMask() {
      return this.isBrazil ? ['# #### ####'] : '##################'
    },
    isDocumentValid() {
      return this.isBrazil ? validaCpfCnpj(this.form.document) : true
    },
    isFormValid() {
      var required = ["name", "email", "confirm_email"];

      for (var i in required) {
        var key = required[i];
        if (!this.form[key]) {
          return false;
        }
      }

      if(window.option_form.request_cpf_cnpj_shopper && !this.form.document) {
        return false;
      }
      if(window.option_form.request_phone_shopper && !this.form.phone) {
        return false;
      }
      if(window.option_form.instagram_shopper && !this.form.instagram) {
        return false;
      }

      return true;
    },
  },
  methods: {
    resetErrors() {
      this.i_errors = {
        ddd: [],
        name: [],
        document: [],
        email: [],
        confirm_email: [],
        phone: [],
        instagram: []
      }
    },
    preSubmitIndex() {
      this.resetErrors();

      if(!this.isDocumentValid) {
        this.i_errors.document = ["Insira um documento válido"];
        return;
      }
      if(this.form.email !== this.form.confirm_email) {
        this.i_errors.confirm_email = ["E-mails digitados são diferentes"];
        return;
      }
      if (window.option_form.request_phone_shopper && this.form.phone.length < 8) {
        this.i_errors.phone = ["Insira um telefone válido"];
        return;
      }
      if (window.option_form.request_phone_shopper && this.isBrazil && this.ddd.length < 2) {
        this.i_errors.ddd = ["Insira um DDD"];
        return;
      }
      if (window.option_form.instagram_shopper && this.form.instagram && this.form.instagram.length > 30) {
        this.i_errors.instagram = ["Insira um perfil válido com até 30 caracteres"];
        return;
      }

      if (this.loading) return;
      this.loading = true;

      window.grecaptcha.execute({ action: "submit" })
        .then((token) => {
          this.submitIndex(token);
        })
        .catch((error) => {
          this.loading = false;
          alert('Erro no reCAPTCHA. Se o problema persistir, tente novamente em outra rede.');
          console.error(error)
        });
    },
    submitIndex(recaptcha_token) {
      var data = JSON.parse(JSON.stringify(this.form));
      data.phone = this.form.phone ? this.country.dialCode + this.ddd + this.form.phone.replace(/\D/g, "") : "";
      data.country = this.country.iso2;
      data.query_params = getUrlParameters();
      data.recaptcha_token = recaptcha_token;

      if(this.optionForm.request_address_shopper) {
        data.address = this.$refs["form-billet"].form;
        try {
          this.$refs["form-billet"].save();
        } catch(e) {}
      }
      if (window.offer) {
        data.offer = window.offer.code;
      }
      if (window.plan) {
        data.plan = window.plan.code;
      }
      if (data.query_params.lot) {
        data.lot = data.query_params.lot;
      }
      if (window.ga4_client_id) {
        data.ga4_client_id = window.ga4_client_id;
      }
      if (window.ga4_session_id) {
        data.ga4_session_id = window.ga4_session_id;
      }
      if (window.lot && window.lot.not_started) {
        Toastify({
          text: "Este ingresso ainda não está liberado para compra.\n Entre em contato com o organizador do evento para obter ajuda.",
          duration: 5000,
          style: {
            background: '#F7EDCA',
            border: '1px solid #D6A016',
            "border-radius": '4px',
            color: "#D6A016",
            'font-size': '14px',
            'box-shadow': '2px 2px 13px -5px rgba(0,0,0,0.75)'
          }
        }).showToast();
        this.loading = false;
        return;
      }

      var locationSearch = window.location.search;
      if (this.appliedCoupon) {
        locationSearch = (locationSearch ? locationSearch + "&coupon=" : "?coupon=") + this.appliedCoupon;
      }
      
      $.ajax({
        type: 'POST',
        url: window.apiUrl + "/v1/shoppers/" + product.code,
        data: JSON.stringify(data),
        contentType: "application/json",
        dataType: 'json'
      })
        .done((data) => {
          this.code = data.code;
          window.localStorage.setItem("name", data.name);
          window.localStorage.setItem("document", data.document);
          window.localStorage.setItem("email", data.email);
          window.localStorage.setItem("fullphone", data.phone);
          window.localStorage.setItem("ddd", this.ddd);
          window.localStorage.setItem("phone", this.form.phone);
          window.localStorage.setItem("instagram", this.form.instagram);

          if (this.longPage) {
            this.loading = false;
            this.preSubmitPayment();
          } else {
            document.location.href = "/pagar/" + data.code + locationSearch;
          }
        })
        .fail((error) => {
          this.loading = false;
          if (error.responseJSON) {
            this.i_errors = error.responseJSON;
          }

          if (this.longPage) {
            $([document.documentElement, document.body]).animate({
              scrollTop: $(".steps-header").offset().top
            }, 200);
          }
        });
    },
    changeBilletInstallments(data) {
      this.billetInstallments = data;
    },
  }
}

/* template */

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = undefined
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/pages/index.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__